var _g, _rect, _rect2, _line, _g2, _rect3, _g3, _circle, _g4, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeaturesImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 126,
    viewBox: "0 0 86 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_282_14408)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 91.7396,
    width: 8.55249,
    height: 20.431,
    rx: 4.27625,
    fill: "#F7D62A"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.950277,
    y: 92.6899,
    width: 6.65194,
    height: 18.5304,
    rx: 3.32597,
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 78.3975,
    y: 92.6899,
    width: 6.65194,
    height: 18.5304,
    rx: 3.32597,
    fill: "#F7D62A",
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 43.2374,
    y1: 59.4301,
    x2: 43.2374,
    y2: 76.06,
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_282_14408)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.7842,
    y: 67.9827,
    width: 20.9061,
    height: 12.3536,
    rx: 6.1768,
    fill: "#F7D62A"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.7345,
    y: 68.9329,
    width: 19.0055,
    height: 10.453,
    rx: 5.22652,
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_282_14408)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 43.2377,
    cy: 53.2533,
    r: 7.60221,
    fill: "#F7D62A"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.2377,
    cy: 53.2533,
    r: 6.65194,
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_282_14408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.27661 100.767C4.27661 86.3346 15.9766 74.6346 30.4092 74.6346H55.5915C70.0242 74.6346 81.7242 86.3346 81.7242 100.767V113.121C81.7242 120.206 75.9806 125.95 68.8954 125.95H17.1054C10.0202 125.95 4.27661 120.206 4.27661 113.121V100.767Z",
    fill: "#F7D62A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22689 100.767C5.22689 86.8594 16.5014 75.5849 30.4092 75.5849H55.5915C69.4994 75.5849 80.7739 86.8594 80.7739 100.767V113.121C80.7739 119.681 75.4557 124.999 68.8954 124.999H17.1054C10.5451 124.999 5.22689 119.681 5.22689 113.121V100.767Z",
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6081,
    cy: 92.6899,
    r: 9.50277,
    fill: "white",
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.6079,
    cy: 92.6899,
    r: 5.22652,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.7082,
    cy: 91.7397,
    r: 1.90055,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9179,
    cy: 92.6899,
    r: 9.50277,
    fill: "white",
    stroke: "#BAA11D",
    strokeWidth: 1.90055
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.9177,
    cy: 92.69,
    r: 5.22652,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.018,
    cy: 91.7397,
    r: 1.90055,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7344 109.32C37.5355 116.684 48.2261 116.684 52.2648 109.32",
    stroke: "#BAA11D",
    strokeWidth: 1.90055,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.704 50.6507L50.0953 51.5164L49.704 50.6507ZM43.7113 53.3593L44.1026 54.225L43.7113 53.3593ZM42.6887 53.3593L42.2975 54.225H42.2975L42.6887 53.3593ZM36.6961 50.6507L36.3048 51.5164L36.6961 50.6507ZM49.7851 40.1923L49.1712 40.9173L49.7851 40.1923ZM40.7989 42.3752C40.2742 42.3752 39.8489 42.8006 39.8489 43.3252C39.8489 43.8499 40.2742 44.2752 40.7989 44.2752V42.3752ZM39.0278 46.4901C39.5525 46.4901 39.9778 46.0647 39.9778 45.5401C39.9778 45.0154 39.5525 44.5901 39.0278 44.5901V46.4901ZM43.3079 46.8029C42.7832 46.8029 42.3579 47.2283 42.3579 47.7529C42.3579 48.2776 42.7832 48.7029 43.3079 48.7029V46.8029ZM44.0653 13.4073C44.59 13.4073 45.0153 12.9819 45.0153 12.4573C45.0153 11.9326 44.59 11.5073 44.0653 11.5073V13.4073ZM43.2716 39.0746C43.2716 39.5993 43.6969 40.0246 44.2216 40.0246C44.7462 40.0246 45.1716 39.5993 45.1716 39.0746H43.2716ZM44.2216 27.277L44.2169 26.327L44.2216 27.277ZM44.2216 24.1889L44.2169 25.1389L44.2216 24.1889ZM44.2216 21.4112L44.2283 22.3612L44.2216 21.4112ZM44.2216 33.143H45.1716C45.1716 32.6183 44.7462 32.193 44.2216 32.193V33.143ZM28.9395 16.2105C28.9395 8.33466 35.3242 1.95 43.2 1.95V0.05C34.2748 0.05 27.0395 7.28532 27.0395 16.2105H28.9395ZM43.2 1.95C51.0759 1.95 57.4606 8.33466 57.4606 16.2105H59.3606C59.3606 7.28532 52.1252 0.05 43.2 0.05V1.95ZM34.4435 30.0723C34.4435 27.2098 32.8765 24.9159 31.539 22.8498C30.1508 20.7054 28.9395 18.7247 28.9395 16.2105H27.0395C27.0395 19.3556 28.5802 21.7757 29.944 23.8823C31.3585 26.0673 32.5435 27.8746 32.5435 30.0723H34.4435ZM57.4606 16.2105C57.4606 18.7282 56.2456 20.7563 54.8586 22.9217C53.5276 24.9995 51.9565 27.2993 51.9565 30.0723H53.8565C53.8565 27.9665 55.0374 26.165 56.4585 23.9465C57.8235 21.8155 59.3606 19.3521 59.3606 16.2105H57.4606ZM49.3127 49.785L43.32 52.4936L44.1026 54.225L50.0953 51.5164L49.3127 49.785ZM43.08 52.4936L37.0873 49.785L36.3048 51.5164L42.2975 54.225L43.08 52.4936ZM43.32 52.4936C43.24 52.5298 43.1601 52.5298 43.08 52.4936L42.2975 54.225C42.875 54.486 43.5251 54.486 44.1026 54.225L43.32 52.4936ZM34.8508 49.1329C34.8508 50.1149 35.3713 51.0944 36.3048 51.5164L37.0873 49.785C36.9412 49.7189 36.7508 49.4934 36.7508 49.1329H34.8508ZM49.6492 49.1329C49.6492 49.4934 49.4589 49.7189 49.3127 49.785L50.0953 51.5164C51.0288 51.0944 51.5492 50.1149 51.5492 49.1329H49.6492ZM48.3008 38.6988H38.0992V40.5989H48.3008V38.6988ZM48.3008 40.5989C48.6335 40.5989 48.9359 40.7181 49.1712 40.9173L50.3989 39.4672C49.8333 38.9884 49.0997 38.6988 48.3008 38.6988V40.5989ZM49.1712 40.9173C49.4652 41.1662 49.6492 41.5347 49.6492 41.9473H51.5492C51.5492 40.9526 51.101 40.0616 50.3989 39.4672L49.1712 40.9173ZM51.9565 30.0723C51.9565 34.8759 50.7426 37.8132 49.0979 39.5363L50.4723 40.8482C52.5652 38.6556 53.8565 35.1761 53.8565 30.0723H51.9565ZM36.7508 41.9473C36.7508 41.5348 36.9348 41.1663 37.2286 40.9175L36.0008 39.4675C35.2989 40.0619 34.8508 40.9528 34.8508 41.9473H36.7508ZM37.2286 40.9175C37.464 40.7182 37.7664 40.5989 38.0992 40.5989V38.6988C37.3002 38.6988 36.5664 38.9885 36.0008 39.4675L37.2286 40.9175ZM37.3019 39.5366C35.6573 37.8135 34.4435 34.8762 34.4435 30.0723H32.5435C32.5435 35.1763 33.8347 38.6558 35.9275 40.8484L37.3019 39.5366ZM49.6492 41.9473V43.3252H51.5492V41.9473H49.6492ZM50.5992 42.3752H40.7989V44.2752H50.5992V42.3752ZM36.7508 49.1329V45.5401H34.8508V49.1329H36.7508ZM36.7508 45.5401V41.9473H34.8508V45.5401H36.7508ZM35.8008 46.4901H39.0278V44.5901H35.8008V46.4901ZM49.6492 43.3252V47.7529H51.5492V43.3252H49.6492ZM49.6492 47.7529V49.1329H51.5492V47.7529H49.6492ZM50.5992 46.8029H43.3079V48.7029H50.5992V46.8029ZM37.934 16.9345C37.934 16.1386 38.4463 15.2794 39.5657 14.5716C40.6732 13.8714 42.2615 13.4073 44.0653 13.4073V11.5073C41.9583 11.5073 40.0059 12.0454 38.5504 12.9656C37.1068 13.8783 36.034 15.2577 36.034 16.9345H37.934ZM44.0653 32.193C42.2615 32.193 40.6732 31.7288 39.5657 31.0287C38.4463 30.3209 37.934 29.4617 37.934 28.6657H36.034C36.034 30.3425 37.1068 31.7219 38.5504 32.6346C40.0059 33.5549 41.9583 34.093 44.0653 34.093V32.193ZM44.0653 19.2729C45.1034 19.2729 46.3648 19.3502 47.3406 19.5619C47.8366 19.6695 48.1861 19.7969 48.3888 19.9195C48.5981 20.0462 48.4661 20.0432 48.4661 19.8673H50.3661C50.3661 19.0759 49.8323 18.5722 49.3723 18.2939C48.9055 18.0115 48.3179 17.8297 47.7434 17.7051C46.578 17.4523 45.164 17.3729 44.0653 17.3729V19.2729ZM37.934 22.8001C37.934 22.0762 38.3536 21.3058 39.2741 20.6351L38.1551 19.0995C36.9193 20.0001 36.034 21.2805 36.034 22.8001H37.934ZM39.2741 20.6351C40.381 19.8285 42.0907 19.2729 44.0653 19.2729V17.3729C41.7666 17.3729 39.6449 18.0139 38.1551 19.0995L39.2741 20.6351ZM44.0653 20.4618C42.0907 20.4618 40.381 19.9061 39.2741 19.0995L38.1551 20.6351C39.6449 21.7207 41.7666 22.3618 44.0653 22.3618V20.4618ZM39.2741 19.0995C38.3536 18.4288 37.934 17.6584 37.934 16.9345H36.034C36.034 18.4542 36.9193 19.7346 38.1551 20.6351L39.2741 19.0995ZM37.934 28.6657C37.934 27.9419 38.3536 27.1714 39.2741 26.5007L38.1551 24.9651C36.9193 25.8657 36.034 27.1461 36.034 28.6657H37.934ZM39.2741 26.5007C40.381 25.6941 42.0907 25.1385 44.0653 25.1385V23.2385C41.7666 23.2385 39.6449 23.8795 38.1551 24.9652L39.2741 26.5007ZM44.0653 26.3274C42.0907 26.3274 40.381 25.7718 39.2741 24.9651L38.1551 26.5007C39.6449 27.5863 41.7666 28.2274 44.0653 28.2274V26.3274ZM39.2741 24.9652C38.3536 24.2944 37.934 23.524 37.934 22.8001H36.034C36.034 24.3198 36.9193 25.6002 38.1551 26.5007L39.2741 24.9652ZM48.4661 25.7329C48.4661 25.6137 48.5593 25.6139 48.3926 25.7205C48.2128 25.8355 47.8924 25.9575 47.4188 26.0596C46.4866 26.2604 45.2686 26.3218 44.2169 26.327L44.2263 28.227C45.308 28.2216 46.6872 28.1607 47.8189 27.917C48.3773 27.7967 48.9555 27.6159 49.4163 27.3212C49.8902 27.0181 50.3661 26.5018 50.3661 25.7329H48.4661ZM44.2169 26.327C44.1658 26.3273 44.1153 26.3274 44.0653 26.3274V28.2274C44.1183 28.2274 44.172 28.2273 44.2263 28.227L44.2169 26.327ZM44.0653 25.1385C44.1153 25.1385 44.1658 25.1386 44.2169 25.1389L44.2263 23.2389C44.172 23.2386 44.1183 23.2385 44.0653 23.2385V25.1385ZM44.2169 25.1389C45.2686 25.144 46.4866 25.2055 47.4188 25.4063C47.8924 25.5083 48.2128 25.6304 48.3926 25.7453C48.5593 25.8519 48.4661 25.8521 48.4661 25.7329H50.3661C50.3661 24.9641 49.8902 24.4478 49.4163 24.1447C48.9555 23.85 48.3773 23.6692 47.8189 23.5489C46.6872 23.3051 45.308 23.2442 44.2263 23.2389L44.2169 25.1389ZM48.4661 19.8673C48.4661 19.6964 48.5923 19.6882 48.4015 19.8073C48.2137 19.9245 47.8845 20.0498 47.4089 20.1576C46.4733 20.3697 45.2524 20.4539 44.2149 20.4612L44.2283 22.3612C45.3242 22.3534 46.7006 22.2664 47.8289 22.0106C48.3852 21.8845 48.9546 21.7017 49.4074 21.4192C49.8572 21.1385 50.3661 20.6389 50.3661 19.8673H48.4661ZM44.2149 20.4612C44.1644 20.4616 44.1146 20.4618 44.0653 20.4618V22.3618C44.119 22.3618 44.1734 22.3616 44.2283 22.3612L44.2149 20.4612ZM45.1716 39.0746V33.143H43.2716V39.0746H45.1716ZM44.0653 34.093H44.2216V32.193H44.0653V34.093Z",
    fill: "#BAA11D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_282_14408",
    x: 0,
    y: 91.7396,
    width: 8.55249,
    height: 20.431,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.80111,
    dy: 1.42542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_282_14408"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_282_14408",
    x: 32.7842,
    y: 67.9827,
    width: 20.906,
    height: 12.3536,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.80111,
    dy: 1.42542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_282_14408"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_282_14408",
    x: 35.6355,
    y: 45.6511,
    width: 15.2043,
    height: 15.2044,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.80111,
    dy: 1.42542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_282_14408"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_282_14408",
    x: 4.27661,
    y: 74.6346,
    width: 77.4475,
    height: 51.3149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.80111,
    dy: 1.42542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_282_14408"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesImg);
export default __webpack_public_path__ + "static/media/featuresImg.bdb378d7f2b28e2e1a21dca6d6a73d57.svg";
export { ForwardRef as ReactComponent };